const megamenu = {
  links: document.querySelectorAll('.jsMenuDrop') as NodeListOf<HTMLElement>,
  menuWrap: document.getElementById('jsMegaWrap') as HTMLElement,

  init() {
    this.getPosition();
    this.resizePosition();

  },

  getPosition() {
    this.links.forEach((dropdown: HTMLElement) => {
      const container = document.getElementById('jsMegaMenu') as HTMLElement;
      const subList = dropdown.querySelector(
        '.desc-nav__sublist',
      ) as HTMLElement | null;
      // const links = dropdown.querySelectorAll(
      //   '.desc-nav__subitem--lvl2',
      // ) as NodeListOf<HTMLElement>;

      if (subList) {
        const sub = subList.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        if (sub.right > containerRect.right) {
          dropdown.style.position = 'revert';
          subList.style.left = 'auto';
        }

      }
    });
  },

  resizePosition() {
    window.addEventListener('resize', () => {
      this.getPosition();
    });
  },


};

export default megamenu;
